import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CrewWeeklyService } from '../../../core/service/crew-weekly-service.service';
import {
  CrewWeeklyDetails,
  CrewWeeklyProject,
  CrewWeeklyRequest,
  CrewWeeklyResponse,
  CrewWeeklyRoutine,
} from '../../../core/interface/CrewWeeklyDetails';
import { CommonService } from '../../../core/service/common.service';
import { weeklyScheduleMX } from '../../../core/constants/constants';
import { Subscription } from 'rxjs';
import { ExportToExcel } from '../../../core/interface/maint-schedule-jobs';
@Component({
  standalone: false,
  selector: 'app-weekly-schedule-drill',
  templateUrl: './weekly-schedule-drill.component.html',
  styleUrl: './weekly-schedule-drill.component.less',
  encapsulation: ViewEncapsulation.None,
})
export class WeeklyScheduleDrillComponent implements OnInit, OnDestroy {
  crewWeeklyReport!: CrewWeeklyResponse | null;
  crewWeeklyDetails: CrewWeeklyDetails[] = [];
  crewWeeklyRoutine: CrewWeeklyRoutine | undefined;
  crewWeeklyProject: CrewWeeklyProject | undefined;
  CrewDetailsList: CrewWeeklyDetails[] = [];
  selectedDate!: Date;
  facId: string = '';
  crew: string = '';
  days: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Total'];
  isLoading: boolean = true;
  searchText: string = '';
  routerData!: ExportToExcel;
  totalSchedules: number = 0;
  weeklyScheduleMX = weeklyScheduleMX;
  getCrewWeeklyReportSub!: Subscription;
  disableNonMondays = (current: Date): boolean => {
    return current.getDay() !== 1;
  };

  constructor(
    private readonly crewWeeklyService: CrewWeeklyService,
    private readonly commonService: CommonService
  ) {}

  ngOnInit() {
    this.routerData = history.state.data;
    if (this.routerData) {
      this.selectedDate = new Date(this.routerData.startDate);
      this.facId = this.routerData.facId;
      this.crew = this.routerData.crew;
      this.getCrewWeeklyReport(this.selectedDate, this.facId, this.crew);
    }
    this.commonService.setNavigationDisabled(true);
  }

  searchData() {
    if (!this.searchText) {
      this.crewWeeklyDetails = this.CrewDetailsList;
      this.totalSchedules = this.crewWeeklyDetails.length;
      return this.crewWeeklyDetails;
    }
    this.crewWeeklyDetails = this.CrewDetailsList.filter((item) =>
      item.EmployeeName.toLowerCase().includes(this.searchText.toLowerCase())
    );
    this.totalSchedules = this.crewWeeklyDetails.length;
    return this.crewWeeklyDetails;
  }

  ngAfterViewInit() {
    this.searchData();
  }

  onSearch() {
    this.searchData();
  }

  onDateChange(event: Date) {
    if (event) {
      this.selectedDate = event;
      this.clearjson();
      this.getCrewWeeklyReport(this.selectedDate, this.facId, this.crew);
    }
  }

  onRefresh() {
    this.clearjson();
    this.getCrewWeeklyReport(this.selectedDate, this.facId, this.crew);
  }

  clearjson() {
    this.isLoading = true;
    this.crewWeeklyDetails = [];
    this.crewWeeklyReport = null;
    this.crewWeeklyRoutine = undefined;
    this.crewWeeklyProject = undefined;
    this.searchText = '';
    this.totalSchedules = 0;
    this.CrewDetailsList = [];
  }

  getCrewWeeklyReport(date: Date, facId: string, crew: string): void {
    this.clearjson();
    const pad = (n: number) => String(n).padStart(2, '0');
    const d = new Date(date);
    const data: CrewWeeklyRequest = {
      facId: facId,
      wdStart: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T00:00:00`,
      crew: crew,
    };
    this.getCrewWeeklyReportSub = this.crewWeeklyService
      .getCrewWeeklyReport(data)
      .subscribe({
        next: (response: CrewWeeklyResponse | null) => {
          this.crewWeeklyReport = response;
          this.isLoading = false;
          if (this.crewWeeklyReport) {
            this.crewWeeklyDetails = this.crewWeeklyReport.CrewWeeklyDetails;
            this.CrewDetailsList = this.crewWeeklyDetails;
            this.totalSchedules = this.crewWeeklyDetails.length;
            this.crewWeeklyRoutine = this.crewWeeklyReport.CrewWeeklyRoutine;
            this.crewWeeklyProject = this.crewWeeklyReport.CrewWeeklyProject;
          }
        },
        error: (error) => {
          console.error(
            'Error occurred in getCrewWeeklyReport method. Error: ',
            error
          );
        },
        complete: () => {},
      });
  }

  getDayWeeklyReport(item: CrewWeeklyDetails, day: string, key: string): any {
    const dayKey = Object.keys(item).find(
      (k) => k.startsWith(day) && k.endsWith(key)
    );
    return dayKey ? item[dayKey] : item[key];
  }

  getRoutineReport(day: string, key: 'SchRout' | 'Rout'): number {
    return this.crewWeeklyRoutine?.[`Sum${day}${key}`] ?? 0;
  }

  getProjectReport(day: string, key: 'SchProj' | 'Proj'): number {
    return this.crewWeeklyProject?.[`Sum${day}${key}`] ?? 0;
  }

  ngOnDestroy(): void {
    if (this.getCrewWeeklyReportSub) {
      this.getCrewWeeklyReportSub.unsubscribe();
    }
    this.commonService.setNavigationDisabled(false);
  }
}
